import { EntityModel } from '@/interfaces'
import {
  ALL_ACCOMMODATION_SERVICES_QUERY,
  CREATE_ACCOMMODATION_SERVICE_MUTATION,
  DELETE_ACCOMMODATION_SERVICE_MUTATION,
  FORCE_DELETE_ACCOMMODATION_SERVICE_MUTATION,
  SINGLE_ACCOMMODATION_SERVICE_QUERY,
  UPDATE_ACCOMMODATION_SERVICE_MUTATION,
} from './graphql'
import ratioAccommodationEntity from '@/entities/ratioAccommodation/entity'

const ratioAccommodationServiceModel: EntityModel = {
  name: 'accommodationService',
  namePlural: 'accommodationServices',
  uniqueName: 'ratioAccommodationService',
  uniqueNamePlural: 'ratioAccommodationServices',
  path: 'travel/pricing/adaptors/ratio/accommodation_service',
  baseUrl: '/travel/pricing/adaptors/ratio/accommodation_services',
  translationPrefix: 'entities:ratioAccommodationService.',
  getDisplayName: (values: any) => {
    return 'Ratio Accommodation Service'
  },
  gql: {
    getAll: ALL_ACCOMMODATION_SERVICES_QUERY,
    getSingle: SINGLE_ACCOMMODATION_SERVICE_QUERY,
    create: CREATE_ACCOMMODATION_SERVICE_MUTATION,
    update: UPDATE_ACCOMMODATION_SERVICE_MUTATION,
    delete: DELETE_ACCOMMODATION_SERVICE_MUTATION,
    forceDelete: FORCE_DELETE_ACCOMMODATION_SERVICE_MUTATION,
  },
  attributes: {
    ratioServiceNo: {
      name: 'ratioServiceNo',
      label: 'entities:ratioAccommodationService.attributes.ratioServiceNo.label',
      type: 'value',
      dataType: 'string',
      defaultInput: true,
      inputType: 'text',
      validationType: 'string',
      validations: [
        {
          type: 'required',
        },
      ],
    },
    accommodation: {
      name: 'accommodation',
      label: 'entities:ratioAccommodationService.attributes.accommodation.label',
      type: 'entityObject',
      dataType: 'any',
      getEntity: () => {
        return ratioAccommodationEntity
      },
      defaultInput: true,
      inputType: 'select',
      validationType: 'string',
      validations: [],
    },
  },
}

export default ratioAccommodationServiceModel
